<template>
    <div class="options-list">
        <div
            v-for="(groupedOption, headerName) in groupedOptions"
            :key="headerName"
            class="pt-4"
        >
            <h3 class="mb-3">
                {{ toHeader(headerName) }}
            </h3>
            <div
                v-if="isColor(groupedOption)"
                class="color-group justify-content-center justify-content-sm-start"
            >
                <color-swatch
                    v-for="colorOption in groupedOption"
                    :key="colorOption.chromeOptionCode"
                    :color="mapColor(colorOption)"
                    :selected="isActive(colorOption)"
                    @click="onSelect"
                />
            </div>
            <div v-else class="equipment-group">
                <equipment-item
                    v-for="option in groupedOption"
                    :key="option.chromeOptionCode"
                    :option="option"
                    :group-size="groupedOption.length"
                    :active="isActive(option)"
                    @select="onSelect"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.color-group {
    display: flex;
    flex-wrap: wrap;

    .color-swatch {
        width: 90px;
    }
}
</style>

<script>
import { get, dispatch } from "vuex-pathify";
import _ from "lodash";
import numeral from "numeral";
import EquipmentItem from "Modules/Configure/components/EquipmentItem";
import ColorSwatch from "Components/ColorSwatch/index";
export default {
    name: "OptionsList",

    components: { ColorSwatch, EquipmentItem },

    props: {
        options: {
            type: Array,
            required: true
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        checklistItems: get("configure/configuration@checklistItems"),
        loading: get("configure/loading"),
        groupedOptions() {
            return _.groupBy(this.options, "headerName");
        }
    },
    methods: {
        onSelect(option) {
            // If required, do not allow "de-selecting"
            if (this.required) {
                const originalOption = _.find(this.options, [
                    "chromeOptionCode",
                    option.chromeOptionCode
                ]);
                if (this.isActive(originalOption)) {
                    return;
                }
            }

            dispatch("configure/selectOption", option.chromeOptionCode);
        },
        isColor(groupedOption) {
            const firstOptionRgbValue = _.get(groupedOption, "[0].rgbValue");
            return !_.isNil(firstOptionRgbValue);
        },
        mapColor(option) {
            const primaryName = _.get(
                _.find(_.get(option, "descriptions"), { type: "PRIMARY_NAME" }),
                "description"
            );
            const cost = _.get(option, "msrp");
            const hex = _.get(option, "rgbValue");
            const chromeOptionCode = _.get(option, "chromeOptionCode");

            let name = primaryName;
            if (!_.isNil(cost) && _.toNumber(cost) > 0) {
                name += ` (+${numeral(cost).format("$0,0")})`;
            }

            return {
                name,
                hex,
                chromeOptionCode
            };
        },
        isActive(option) {
            return (
                _.indexOf(
                    ["SELECTED", "INCLUDED", "REQUIRED"],
                    _.get(option, "selectionState")
                ) !== -1
            );
        },
        toHeader(headerName) {
            return _.startCase(_.toLower(headerName));
        }
    }
};
</script>
